import React, { useEffect, useMemo, useState } from 'react';
import styled from '@emotion/styled';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Colors, Container, device } from 'utils';
import { Logo } from 'images';
import { LoginForm } from 'components';
import { Modal } from 'utils';
import ExternalLink from 'components/ExternalLink/ExternalLink';
import BurgerMini from './Icons/BurgerIcon';
import ArrowDownIcon from './Icons/ArrowDownIcon';
import HelpCircleIcon from './Icons/HelpCircleIcon';
import LockIcon from './Icons/LockIcon';
import InfoCircleIcon from './Icons/InfoCircleIcon';
import LifeBuoyIcon from './Icons/LifeBuoyIcon';
import BuildingIcon from './Icons/BuildingIcon';
import MailIcon from './Icons/MailIcon';
import BookIcon from './Icons/BookIcon';
import MicrophoneIcon from './Icons/MicrophoneIcon';

const HELP_ITEMS = [
  { label: 'Wie funktioniert es?', to: '/how-it-works', icon: <HelpCircleIcon /> },
  { label: 'Vertrauen & Sicherheit', to: '/transparency-and-trust', icon: <LockIcon /> },
  { label: 'Richtlinien', to: '/guidelines', icon: <InfoCircleIcon /> },
  { label: 'Häufig gestellte Fragen (FAQ)', to: '/faqs', icon: <LifeBuoyIcon /> },
  { label: 'Über uns', to: '/about-us', icon: <BuildingIcon /> },
  { label: 'Kontakt', to: '/contact-us', icon: <MailIcon /> },
];

const COMMUNITY_ITEMS = [
  {
    title: 'Blog',
    description: 'Bleibe up-to-date und erweitere deinen Horizont mit unserem Blog.',
    href: 'https://blog.commonsplace.de/',
    icon: <BookIcon />,
    cta: 'Blog öffnen',
    badge: 'Neu',
  },
  {
    title: 'Podcast',
    description: 'Spannende Interviews, aktuelle Themen und interessante Talks.',
    href: 'https://podcast.commonsplace.de/',
    icon: <MicrophoneIcon />,
    cta: 'Jetzt reinhören',
    badge: 'Neu',
  },
];

const ADMIN_LINKS = [
  {
    title: 'Admin All Projects',

    href: '/admin/all-projects',
  },

  {
    title: 'Admin Promotions',

    href: '/admin/promotions',
  },

  // {

  //   title: 'Alle Spenden',

  //   href: '/admin/all-donations',

  // },

  {
    title: 'Alle Kategorie',

    href: '/admin/all-category',
  },

  {
    title: 'Select Home Projects',

    href: '/admin/select-projects',
  },

  {
    title: 'Select Priority Projects',

    href: '/admin/priority-projects',
  },

  {
    title: 'Invoices',

    href: '/admin/invoices',
  },

  {
    title: 'Newsletter',

    href: '/admin/newsletter',
  },

  {
    title: 'Add Funding Days',

    href: '/admin/addfunding',
  },

  {
    title: 'Create Draft',

    href: '/admin/createdraft',
  },

  {
    title: 'Booked Goodies',

    href: '/admin/bookedgoodies',
  },
  {
    title: "Recurring Payments",
    href: "/admin/recurring-payments",
  },
  {
    title: "Participants List",
    href: "/admin/participants",
  },
  {
    title: "Einstellungen",
    href: "/admin/settings",
  }
];

function Header({ projectForm }) {
  const history = useHistory();
  const location = useLocation();

  const [menuOpen, setMenuOpen] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showAdminProfileNotice, setShowAdminProfileNotice] = useState(false);
  const [openMobileDropdown, setOpenMobileDropdown] = useState(null);
  const [isMobileView, setIsMobileView] = useState(
    typeof window !== 'undefined'
      ? window.matchMedia('(max-width: 767px)').matches
      : false
  );

  useEffect(() => {
    const media = window.matchMedia('(max-width: 767px)');
    const handler = (e) => setIsMobileView(e.matches);

    setIsMobileView(media.matches);

    if (media.addEventListener) {
      media.addEventListener('change', handler);
    } else {
      media.addListener(handler);
    }

    return () => {
      if (media.removeEventListener) {
        media.removeEventListener('change', handler);
      } else {
        media.removeListener(handler);
      }
    };
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : 'unset';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [menuOpen]);

  const isLoggedIn = useMemo(() => {
    const client = localStorage.getItem('client');
    const uid = localStorage.getItem('uid');
    const access = localStorage.getItem('access-token');
    const user = localStorage.getItem('user');
    return !!(user && access && uid && client);
  }, []);

  const loginText = isLoggedIn ? 'Mein Profil' : 'Einloggen';
  const userType = localStorage.getItem('user-type');
  const isAdmin = userType === 'admin';

  const goStartProject = () => {
    setMenuOpen(false);
    history.push('/start-project');
  };

  const toggleMobileDropdown = (key) => {
    setOpenMobileDropdown((prev) => (prev === key ? null : key));
  };

  const showProfile = () => {
    setMenuOpen(false);

    if (isAdmin) {
      setShowAdminProfileNotice(true);
      return;
    }

    history.push('/profile');
  };

  return (
    <>
      <HeaderShell $showShadow={projectForm}>
        <Container>
          <NavBar>
            <LeftNav>
              {!isMobileView && (
                <DesktopNav>
                  <NavItem as="a" href="/projects">
                    Projekte
                  </NavItem>
                  <NavItem as="a" href="/events">
                    Events
                  </NavItem>
                  <NavItem
                    as="a"
                    href="/freitags-sadaqah?utm_campaign=menüdesk"
                  >
                    Freitag
                  </NavItem>

                  <Dropdown>
                    <DropdownTrigger>
                      <span>Hilfe</span>
                      <ArrowDownIcon />
                    </DropdownTrigger>

                    <HelpDropdownMenu>
                      {HELP_ITEMS.map((item) => (
                        <DropdownLinkRow
                          key={item.label}
                          as={Link}
                          to={item.to}
                        >
                          <DropdownIcon>{item.icon}</DropdownIcon>
                          <DropdownText>{item.label}</DropdownText>
                        </DropdownLinkRow>
                      ))}
                    </HelpDropdownMenu>
                  </Dropdown>

                  <Dropdown>
                    <DropdownTrigger>
                      <span>Community</span>
                      <ArrowDownIcon />
                    </DropdownTrigger>

                    <CommunityDropdownMenu>
                      {COMMUNITY_ITEMS.map((item) => (
                        <CommunityCard
                          key={item.title}
                          href={item.href}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <CommunityIcon>{item.icon}</CommunityIcon>

                          <CommunityContent>
                            <CommunityHeader>
                              <CommunityTitle>{item.title}</CommunityTitle>
                              {item.badge ? <Badge>{item.badge}</Badge> : null}
                            </CommunityHeader>

                            <CommunityDescription>
                              {item.description}
                            </CommunityDescription>
                            <CommunityCta>{item.cta}</CommunityCta>
                          </CommunityContent>
                        </CommunityCard>
                      ))}
                    </CommunityDropdownMenu>
                  </Dropdown>
                </DesktopNav>
              )}
            </LeftNav>

            <CenterLogo>
              <ExternalLink href="/">
                <LogoImage
                  src={
                    'https://cdn.prod.website-files.com/677e8c6239136af36bc65f94/677e956903bbb028e9d12638_b3f8733e19dbacc0014314b036af41fe_logo-p-500.png'
                  }
                  alt="commonsplace logo"
                />
              </ExternalLink>
            </CenterLogo>

            <RightNav>
              {!isMobileView ? (
                <DesktopActions>
                  {userType === 'admin' && (
                    <Dropdown>
                      <DropdownTrigger>
                        <span>Admin</span>
                        <ArrowDownIcon />
                      </DropdownTrigger>

                      <HelpDropdownMenu>
                        {ADMIN_LINKS.map((item) => (
                          <DropdownLinkRow
                            key={item.title}
                            as={Link}
                            to={item.href}
                          >
                            <DropdownText>{item.title}</DropdownText>
                          </DropdownLinkRow>
                        ))}
                      </HelpDropdownMenu>
                    </Dropdown>
                  )}
                  {isLoggedIn ? (
                    <SecondaryButton type="button" onClick={showProfile}>
                      {loginText}
                    </SecondaryButton>
                  ) : (
                    <SecondaryButton
                      type="button"
                      onClick={() => setShowLoginModal(true)}
                    >
                      Einloggen
                    </SecondaryButton>
                  )}

                  <PrimaryButton type="button" onClick={goStartProject}>
                    Projekt starten
                  </PrimaryButton>
                </DesktopActions>
              ) : (
                <BurgerButton
                  type="button"
                  onClick={() => setMenuOpen((prev) => !prev)}
                  aria-label="menu"
                >
                  <BurgerMini />
                </BurgerButton>
              )}
            </RightNav>
          </NavBar>
        </Container>
      </HeaderShell>

      {isMobileView && (
        <>
          <MobileMenuPanel $open={menuOpen}>
            <MobileMenuInner>
              <MobileTop>
                <ExternalLink href="/">
                  <LogoImage src={Logo} alt="commonsplace logo" />
                </ExternalLink>

                <BurgerButton
                  type="button"
                  onClick={() => setMenuOpen(false)}
                  aria-label="close menu"
                >
                  <BurgerMini />
                </BurgerButton>
              </MobileTop>

              <MobileNav>
                <MobileNavLink
                  as="a"
                  href="/projects"
                  onClick={() => setMenuOpen(false)}
                >
                  Projekte
                </MobileNavLink>

                <MobileNavLink
                  as="a"
                  href="/events"
                  onClick={() => setMenuOpen(false)}
                >
                  Events
                </MobileNavLink>

                <MobileNavLink
                  as="a"
                  href="/freitags-sadaqah?utm_campaign=menüdesk"
                  onClick={() => setMenuOpen(false)}
                >
                  Freitag
                </MobileNavLink>

                {userType === 'admin' && (
                  <MobileDropdownSection>
                    <MobileDropdownTrigger
                      onClick={() => toggleMobileDropdown('admin')}
                    >
                      <span>ADMIN</span>
                      <ArrowDownWrap $open={openMobileDropdown === 'admin'}>
                        <ArrowDownIcon />
                      </ArrowDownWrap>
                    </MobileDropdownTrigger>

                    <MobileDropdownContent
                      $open={openMobileDropdown === 'admin'}
                    >
                      {ADMIN_LINKS.map((item) => (
                        <MobileSubLink
                          key={item.title}
                          as={Link}
                          to={item.href}
                          onClick={() => setMenuOpen(false)}
                        >
                          {item.title}
                        </MobileSubLink>
                      ))}
                    </MobileDropdownContent>
                  </MobileDropdownSection>
                )}

                <MobileDropdownSection>
                  <MobileDropdownTrigger
                    onClick={() => toggleMobileDropdown('hilfe')}
                  >
                    <span>Hilfe</span>
                    <ArrowDownWrap $open={openMobileDropdown === 'hilfe'}>
                      <ArrowDownIcon />
                    </ArrowDownWrap>
                  </MobileDropdownTrigger>

                  <MobileDropdownContent $open={openMobileDropdown === 'hilfe'}>
                    {HELP_ITEMS.map((item) => (
                      <MobileSubLink
                        key={item.label}
                        as={Link}
                        to={item.to}
                        onClick={() => setMenuOpen(false)}
                      >
                        {item.label}
                      </MobileSubLink>
                    ))}
                  </MobileDropdownContent>
                </MobileDropdownSection>

                <MobileDropdownSection>
                  <MobileDropdownTrigger
                    onClick={() => toggleMobileDropdown('community')}
                  >
                    <span>Community</span>
                    <ArrowDownWrap $open={openMobileDropdown === 'community'}>
                      <ArrowDownIcon />
                    </ArrowDownWrap>
                  </MobileDropdownTrigger>

                  <MobileDropdownContent
                    $open={openMobileDropdown === 'community'}
                  >
                    <MobileExternalLink
                      href="https://blog.commonsplace.de/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Blog
                    </MobileExternalLink>

                    <MobileExternalLink
                      href="https://podcast.commonsplace.de/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Podcast
                    </MobileExternalLink>
                  </MobileDropdownContent>
                </MobileDropdownSection>
              </MobileNav>

              <MobileActions>
                <PrimaryButton type="button" onClick={goStartProject}>
                  Projekt starten
                </PrimaryButton>

                {isLoggedIn ? (
                  <SecondaryButton
                    type="button"
                    onClick={showProfile}
                  >
                    {loginText}
                  </SecondaryButton>
                ) : (
                  <SecondaryButton
                    type="button"
                    onClick={() => {
                      setMenuOpen(false);
                      setShowLoginModal(true);
                    }}
                  >
                    Einloggen
                  </SecondaryButton>
                )}
              </MobileActions>
            </MobileMenuInner>
          </MobileMenuPanel>

          <MobileOverlay $open={menuOpen} onClick={() => setMenuOpen(false)} />
        </>
      )}

      <Modal
        showModal={showLoginModal}
        handelCloseModal={() => setShowLoginModal(false)}
      >
        <LoginForm />
      </Modal>

      <Modal
        showModal={showAdminProfileNotice}
        handelCloseModal={() => setShowAdminProfileNotice(false)}
      >
        <AdminProfileNotice>
          <AdminProfileNoticeTitle>
            Kein Benutzerprofil verfügbar
          </AdminProfileNoticeTitle>
          <AdminProfileNoticeText>
            Du bist als Admin angemeldet. Admin-Konten haben kein
            Benutzerprofil.
          </AdminProfileNoticeText>
          <PrimaryButton
            type="button"
            onClick={() => setShowAdminProfileNotice(false)}
          >
            Verstanden
          </PrimaryButton>
        </AdminProfileNotice>
      </Modal>
    </>
  );
}

Header.propTypes = {
  projectForm: PropTypes.bool,
};

Header.defaultProps = {
  projectForm: false,
};

export default connect()(Header);

const AdminProfileNotice = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding: 8px;
`;

const AdminProfileNoticeTitle = styled.h2`
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-size: 24px;
  line-height: 32px;
  color: #181d27;
`;

const AdminProfileNoticeText = styled.p`
  margin: 0;
  font-family: 'Inter', sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: #414651;
`;

const HeaderShell = styled.header`
  width: 100%;
  background: #fff;
  position: sticky;
  top: 0;
  z-index: 50;
  box-shadow: ${({ $showShadow }) =>
    $showShadow
      ? `0 16px 24px 2px rgba(0, 0, 0, 0.14),
         0 6px 30px 5px rgba(0, 0, 0, 0.12),
         0 8px 10px -5px rgba(0, 0, 0, 0.2)`
      : 'none'};
`;

const NavBar = styled.div`
  height: 92px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;

  @media ${device.allMobile} {
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;
const LeftNav = styled.div`
  display: flex;
  align-items: center;

  @media ${device.allMobile} {
    display: none;
  }
`;

const CenterLogo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  @media ${device.allMobile} {
    justify-content: flex-start;
    flex: 1;
  }
`;
const RightNav = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  @media ${device.allMobile} {
    flex: 0 0 auto;
  }
`;

const LogoImage = styled.img`
  width: 148px;
  height: auto;
  display: block;
`;

const DesktopNav = styled.div`
  display: flex;
  align-items: center;
  gap: 28px;
`;

const NavItem = styled.a`
  text-decoration: none;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #414651;
  display: inline-flex;
  align-items: center;

  &:hover {
    color: #181d27;
  }
`;

const Dropdown = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  &:hover > div:last-child,
  &:hover > nav,
  &:hover > a + nav {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
`;

const DropdownTrigger = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: #414651;

  &:hover {
    color: #181d27;
  }
`;

const HelpDropdownMenu = styled.nav`
  position: absolute;
  top: calc(100% + 18px);
  left: 0;
  width: 320px;
  background: #ffffff;
  border: 1px solid #e9eaeb;
  border-radius: 18px;
  box-shadow: 0px 12px 24px rgba(16, 24, 40, 0.12);
  padding: 12px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: 0.2s ease;
  z-index: 30;
`;

const DropdownLinkRow = styled.a`
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 12px;
  text-decoration: none;
  border-radius: 12px;

  &:hover {
    background: #f8faf7;
  }
`;

const DropdownIcon = styled.div`
  width: 28px;
  height: 28px;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DropdownText = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #181d27;
`;

const CommunityDropdownMenu = styled.nav`
  position: absolute;
  top: calc(100% + 18px);
  left: 0;
  width: 640px;
  background: #ffffff;
  border: 1px solid #e9eaeb;
  border-radius: 18px;
  box-shadow: 0px 12px 24px rgba(16, 24, 40, 0.12);
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(10px);
  transition: 0.2s ease;
  z-index: 30;
`;

const CommunityCard = styled.a`
  display: flex;
  gap: 14px;
  padding: 14px;
  border-radius: 14px;
  text-decoration: none;

  &:hover {
    background: #f8faf7;
  }
`;

const CommunityIcon = styled.div`
  width: 28px;
  height: 28px;
  flex: 0 0 auto;
`;

const CommunityContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const CommunityHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CommunityTitle = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #181d27;
`;

const CommunityDescription = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #535862;
`;

const CommunityCta = styled.div`
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #3f621a;
`;

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 2px 6px;
  border-radius: 999px;
  border: 1px solid #d5d7da;
  background: #ffffff;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #414651;
`;

const DesktopActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const BaseButton = styled.button`
  height: 44px;
  border-radius: 10px;
  padding: 10px 18px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const SecondaryButton = styled(BaseButton)`
  background: #ffffff;
  color: #414651;
  border: 1px solid #d5d7da;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  transition: background-color 0.2s ease;
  &:hover {
    background-color: #fafafa;
    color: #252b37;
  }
`;

const PrimaryButton = styled(BaseButton)`
  background: #9dbc60;
  color: #ffffff;
  border: 1px solid #8fb153;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05),
    inset 0px 0px 0px 1px rgba(10, 13, 18, 0.18),
    inset 0px -2px 0px rgba(10, 13, 18, 0.05);

  transition: background-color 0.2s ease;
  &:hover {
    background: #3f621a;
  }
`;

const BurgerButton = styled.button`
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const MobileOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(16, 24, 40, 0.35);
  z-index: 59;
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  visibility: ${({ $open }) => ($open ? 'visible' : 'hidden')};
  transition: 0.2s ease;
`;

const MobileMenuPanel = styled.div`
  position: fixed;
  inset: 0 auto 0 0;
  width: min(100vw, 560px);
  background: #f8f8f8;
  z-index: 99999;
  transform: translateX(${({ $open }) => ($open ? '0' : '-100%')});
  transition: transform 0.28s ease;
  border-right: 1px solid #e5e7eb;
`;

const MobileMenuInner = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const MobileTop = styled.div`
  height: 88px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const MobileNav = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 16px 0;
  gap: 10px;
`;

const MobileNavLink = styled.a`
  padding: 14px 0;
  text-decoration: none;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #181d27;
`;

const MobileDropdownSection = styled.div`
  border-bottom: 1px solid #e5e7eb;
`;

const MobileDropdownTrigger = styled.button`
  width: 100%;
  padding: 14px 0;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  color: #181d27;
  cursor: pointer;
`;

const ArrowDownWrap = styled.span`
  display: inline-flex;
  transform: rotate(${({ $open }) => ($open ? '180deg' : '0deg')});
  transition: transform 0.2s ease;
`;

const MobileDropdownContent = styled.div`
  max-height: ${({ $open }) => ($open ? '240px' : '0')};
  overflow: hidden;
  transition: max-height 0.25s ease;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding-bottom: ${({ $open }) => ($open ? '12px' : '0')};
`;

const MobileSubLink = styled.a`
  text-decoration: none;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #414651;
`;

const MobileExternalLink = styled.a`
  text-decoration: none;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #414651;
`;

const MobileActions = styled.div`
  margin-top: auto;
  padding: 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  gap: 14px;
  
`;
